
// Import vendor modules.
import { Application } from "@hotwired/stimulus";
import { Controller } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";

// Import application modules.
import "./common/turbo-stream-actions.js";
import { apiClient } from "./injector.js";
import { BlogPostController } from "./blog-post.controller.js";
import { BlogRelatedPostsController } from "./blog-related-posts.controller.js";
import { BlogTitleController } from "./blog-title.controller.js";
import { ClickOutsideController } from "./common/click-outside.controller.js";
import { CommentContentController } from "./comment-content.controller.js";
import { CommentFormController } from "./comment-form.controller.js";
import { ContactFormController } from "./contact-form.controller.js";
import { EmojisController } from "./emojis.controller.js";
import { NavController } from "./nav.controller.js";
import { NavThemeController } from "./nav-theme.controller.js";
import { PrismController } from "./prism.controller.js";
import { ScrollToController } from "./common/scroll-to.controller.js";
import { SitePhotosController } from "./site-photos.controller.js";

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

/**
* Not every section of the site is Hotwire compatible. When the user clicks through to
* certain areas, we have to disable the Hotwire orchestration.
*/
document.documentElement.addEventListener(
	"turbo:click",
	function handleClick( event ) {

		var targetUrl = event.detail.url;
		var patterns = [
			"/books\\b",
			"/resources\\b",
			"/utils\\b"
		];

		for ( var pattern of patterns ) {

			if ( targetUrl.search( new RegExp( pattern, "i" ) ) >= 0 ) {

				event.preventDefault();
				return;

			}

		}

	}
);

// Scroll down to the desired element (via ID selector).
document.documentElement.addEventListener(
	"turbo:load",
	function handleLoad( event ) {

		var searchParams = new URLSearchParams( location.search );
		var scrollTo = searchParams.get( "scrollTo" );

		if ( ! scrollTo ) {

			return;

		}

		document.querySelector( `#${ scrollTo }` )
			?.scrollIntoView()
		;

	}
);

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

window.Stimulus = Application.start();
// Register Stimulus controllers that we're currently using.
Stimulus.register( "blog-post", BlogPostController );
Stimulus.register( "blog-related-posts", BlogRelatedPostsController );
Stimulus.register( "blog-title", BlogTitleController );
Stimulus.register( "click-outside", ClickOutsideController );
Stimulus.register( "comment-content", CommentContentController );
Stimulus.register( "comment-form", CommentFormController );
Stimulus.register( "contact-form", ContactFormController );
Stimulus.register( "emojis", EmojisController );
Stimulus.register( "nav", NavController );
Stimulus.register( "nav-theme", NavThemeController );
Stimulus.register( "prism", PrismController );
Stimulus.register( "scroll-to", ScrollToController );
Stimulus.register( "site-photos", SitePhotosController );
